import PropTypes from "prop-types";
import React from "react";
import ErrorScreen from "./ErrorScreen";

const CHUNK_ERROR_KEY = "chunk_error_reload";

function isChunkLoadError(error) {
  return (
    error?.name === "ChunkLoadError" ||
    error.message?.includes(
      "'text/html' is not a valid JavaScript MIME type",
    ) ||
    error.message?.includes("error loading dynamically imported module") ||
    error.message?.includes("Failed to fetch dynamically imported module") ||
    error.message?.includes("Importing a module script failed") ||
    error.message?.includes("Loading chunk")
  );
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (isChunkLoadError(error)) {
      if (!sessionStorage.getItem(CHUNK_ERROR_KEY)) {
        sessionStorage.setItem(CHUNK_ERROR_KEY, "1");
        window.location.reload();
        return null;
      }
      sessionStorage.removeItem(CHUNK_ERROR_KEY);
    }

    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] error:", error?.message, error);
    console.error("[ErrorBoundary] component stack:", info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorScreen variant="crash" />;
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
